import { HybridSettingsState } from './model'
import { AppState } from '../../../../types';
import { Environment } from '../../../../remote-api/CoreServicesRemoteApi';
import { ARMServer } from '../../../../remote-api/models';

const getAll = (state: AppState): HybridSettingsState => state.monitoring.hybridSettings;

export const isConfigurationApplying = (state: AppState): boolean => getAll(state).configurationApplying;
export const getIsLoading = (state: AppState) => getAll(state).isLoading;
export const getAllServers = (state: AppState): ARMServer[] => getAll(state).servers || [];
export const getServersLoading = (state: AppState) => getAll(state).serversLoading;
export const getSelectedServerId = (state: AppState) => getAll(state).selectedServer;
export const getSelectedServerGroupId = (state: AppState) => getAll(state).selectedServerGroup;

export const getAmZipUrl = (state: AppState) => getAll(state).amZipUrl;
export const getAllEnvironments = (state: AppState): Environment[] =>
    state.monitoring.resources.environments.data;
export const getSelectedEnvironment = (state: AppState): string | undefined =>
    state.monitoring.resources.environments.selected;
export const getEnvironmentsLoading = (state: AppState): boolean =>
    state.monitoring.resources.environments.loading;